import React from "react";
import {
  agarni,
  amarAdmission,
  bgift,
  gazipurCommerceCollege,
  royalNursing,
} from "../../assets/index";

const Partners = () => {
  return (
    <div className="w-full mx-auto">
      <div className="max-w-screen-xl py-20 mx-auto border-b borer-b-[1px] border-b-primeColor">
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-5xl font-titleFont text-center font-bold text-primeColor ">
            Our Associated Institutions
          </h1>
          <span className="w-32 h-1 mt-2 bg-primeColor inline-block"></span>
        </div>
        <div className="w-full mx-auto grid grid-cols-2 px-4 md:grid-cols-4 xl:grid-cols-5  place-content-center gap-6 xl:gap-0 py-6">
          <img
            className="w-44 h-44 object-fill cursor-pointer"
            src={agarni}
            alt="agarni"
          />
          <img
            className="w-44 h-44 object-fill cursor-pointer"
            src={bgift}
            alt="bgift"
          />
          <img
            className="w-44 h-44 object-fill cursor-pointer"
            src={gazipurCommerceCollege}
            alt="gazipurCommerceCollege"
          />
          <img
            className="w-44 h-44 object-fill cursor-pointer"
            src={royalNursing}
            alt="royalNursing"
          />
          <img
            className="w-44 h-44 object-fill cursor-pointer"
            src={amarAdmission}
            alt="amarAdmission"
          />
        </div>
      </div>
    </div>
  );
};

export default Partners;
